/* eslint-disable @typescript-eslint/consistent-type-exports */
import {type QEPSystemType} from './qep-system';

export * from './account';
export * from './algo';
export * from './algo/db-algo';
export * from './algo/fe-algo';
export * from './common';
export * from './connectivity';
export * from './defaults';
export * from './error';
export * from './finsemble';
export * from './inventory';
export * from './linker';
export * from './marketData';
export * from './options';
export * from './order';
export * from './qep-system';
export * from './traderdb';
export * from './webgateway';

declare global {
  /** Runtime preload singleton exposed on both `window` and `globalThis`. */
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Global runtime declarations must use `var` to describe the preload binding.
  var QEP: QEPSystemType;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  type db = Record<string, unknown>;

  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    QEP: QEPSystemType;
  }
}
